<div class="prospects-main-page records-page">
    <div class="datatable-page-shell">
        <div class="records-page__hero prospects-main-hero">
            <div class="records-page__hero-primary">
                <div class="records-page__hero-headline">
                    <span class="records-page__hero-eyebrow">{{ 'PROSPECTS' | translate }}</span>
                    <h3 class="records-page__hero-title">{{ 'YOUR_PROSPECTS' | translate }}</h3>
                </div>
            </div>
            <div class="records-page__hero-aside">
                <div class="records-page__hero-actions">
                    <ng-select class="saved-search-select" [items]="prospectSavedSearches" bindLabel="name" bindValue="id"
                        [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                        (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
                    </ng-select>
                    <button *ngIf="doWhat.isAdmin || doWhat.canCreate" type="button" class="blue-button" (click)="onAddNew()">{{ 'ADD_PROSPECT' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="details-tab-surface prospects-main-surface datatable-page-surface">
            <app-campaign-datatable class="records-page__table" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite" [iCanDelete]="doWhat.canDelete"
                [iColumns]="columns" [iSortColumn]="'lastName,firstName'" [iRowLinkHandler]="getRowLink"
                (oDeleteRows)="deleteRows($event)" (oEditRow)="editRow($event)" [iData$]="clientsData" [iShowMerge]="true"
                (oMergeRecords)="handleMergeRecordsClicked($event)" [iIsServerLoading]="true" [iTotalCount]="dataTotalCount"
                (oLoadDataFromServer)="onLoadingData($event)" (oCustomDataExport)="export()" [iIsCustomDataExport]="true">
            </app-campaign-datatable>
        </div>
    </div>
</div>